(() => {
  document.querySelectorAll('[data-quality-comparison]').forEach((comparison) => {
    const range = comparison.querySelector('input[type="range"]');
    if (!range) return;

    const updateComparison = () => {
      comparison.style.setProperty('--cr-compare-position', `${range.value}%`);
    };

    updateComparison();
    range.addEventListener('input', updateComparison);
  });

  const stickyCta = document.querySelector('[data-crearto-sticky-cta]');
  const hero = document.querySelector('.cr-hero');
  const finalCta = document.querySelector('.cr-final');

  if (!stickyCta || !hero) return;

  const updateStickyCta = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) {
      stickyCta.classList.remove('is-visible');
      stickyCta.setAttribute('aria-hidden', 'true');
      return;
    }

    const heroBottom = hero.getBoundingClientRect().bottom;
    const finalTop = finalCta ? finalCta.getBoundingClientRect().top : window.innerHeight + 1;
    const shouldShow = heroBottom < 120 && finalTop > window.innerHeight * 0.72;

    stickyCta.classList.toggle('is-visible', shouldShow);
    stickyCta.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  updateStickyCta();
  window.addEventListener('scroll', updateStickyCta, { passive: true });
  window.addEventListener('resize', updateStickyCta);
})();
